import { BitcoinFaceLogoProps } from "../../store/faces";

const BitcoinFace107 = (props: BitcoinFaceLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 147 147"
    width={props.width}
    height={props.height}
  >
    <g clipPath="url(#prefix__a)">
      <path fill="#EFE2DB" d="M150.675 0H0v150.675h150.675V0Z" />
      <path fill="#001A1B" d="M148.47 77.488H0v69.776h148.47V77.488Z" />
      <path fill="#BCAFB1" d="M116.092 95.356H33.956v52.232h82.136V95.356Z" />
      <path fill="#172027" d="M86.574 84.582H61.965v63.006h24.61V84.582Z" />
      <path
        fill="#F5B659"
        d="M24.255 72.15c0 28.348 22.385 51.33 49.999 51.33s50.002-22.982 50.002-51.33"
      />
      <path
        fill="#ECDEA0"
        d="M27.383 72.15c0 26.576 20.986 48.119 46.874 48.119s46.87-21.543 46.87-48.119"
      />
      <path
        fill="#E18D27"
        d="M33.63 72.15c0 23.032 18.188 41.704 40.624 41.704 22.437 0 40.622-18.669 40.622-41.704"
      />
      <path
        fill="#ECDEA0"
        d="M74.498 113.854h-.49V75.106h40.868v.505H74.498v38.243Z"
      />
      <path
        fill="#ECDEA0"
        d="m102.214 101.211-29.018-26.48 38.633 13.22-.156.478L75.31 75.986l27.23 24.847-.326.378Z"
      />
      <path
        fill="#ECDEA0"
        d="M89.654 110.75 74.029 75.462l.447-.207 15.625 35.286-.447.209Z"
      />
      <path
        fill="#ECDEA0"
        d="M74.498 113.854h-.49V75.611H33.628v-.505H74.5v38.748Z"
      />
      <path
        fill="#ECDEA0"
        d="m46.292 101.211-.327-.378 27.23-24.847-36.363 12.443-.156-.478 38.634-13.22-29.018 26.48Z"
      />
      <path
        fill="#ECDEA0"
        d="m58.851 110.75-.447-.209L74.03 75.255l.447.207-15.625 35.288Z"
      />
      <path
        fill="#AEA4B3"
        d="M97.69 88.442a1.856 1.856 0 1 1 1.809-1.86 1.833 1.833 0 0 1-1.809 1.86Zm0-3.207a1.353 1.353 0 1 0 1.323 1.35 1.336 1.336 0 0 0-1.323-1.35ZM94.562 85.235a1.857 1.857 0 1 1 1.808-1.857 1.836 1.836 0 0 1-1.808 1.857Zm0-3.21a1.353 1.353 0 1 0 1.323 1.353 1.336 1.336 0 0 0-1.323-1.353ZM108.627 85.235c-1.858 0-3.371-1.553-3.371-3.46 0-1.909 1.513-3.461 3.371-3.461s3.369 1.552 3.369 3.46-1.511 3.46-3.369 3.46Zm0-6.417c-1.587 0-2.88 1.323-2.88 2.956s1.293 2.957 2.88 2.957c1.588 0 2.878-1.323 2.878-2.957 0-1.633-1.29-2.956-2.878-2.956ZM100.814 78.818a1.857 1.857 0 1 1 1.808-1.857 1.83 1.83 0 0 1-1.808 1.857Zm0-3.207a1.35 1.35 0 0 0-1.36 1.598 1.353 1.353 0 0 0 2.683-.248 1.326 1.326 0 0 0-.381-.95 1.33 1.33 0 0 0-.942-.4ZM71.129 107.69c-1.858 0-3.37-1.552-3.37-3.46s1.512-3.46 3.37-3.46 3.37 1.552 3.37 3.46-1.512 3.46-3.37 3.46Zm0-6.416c-1.588 0-2.88 1.323-2.88 2.956s1.292 2.956 2.88 2.956c1.587 0 2.878-1.323 2.878-2.956s-1.29-2.956-2.878-2.956ZM66.441 101.274a1.855 1.855 0 0 1-1.378-3.152 1.856 1.856 0 0 1 3.186 1.297 1.835 1.835 0 0 1-1.808 1.855Zm0-3.208a1.352 1.352 0 1 0 1.323 1.353 1.335 1.335 0 0 0-1.323-1.353ZM57.067 88.442a1.856 1.856 0 1 1 1.808-1.86 1.835 1.835 0 0 1-1.808 1.86Zm0-3.207a1.353 1.353 0 1 0 1.323 1.35 1.334 1.334 0 0 0-1.323-1.35ZM47.693 82.026A1.857 1.857 0 1 1 49.5 80.17a1.833 1.833 0 0 1-1.808 1.856Zm0-3.208a1.353 1.353 0 1 0 1.323 1.352 1.336 1.336 0 0 0-1.323-1.352ZM38.317 82.026a1.856 1.856 0 1 1 1.808-1.856 1.833 1.833 0 0 1-1.808 1.856Zm0-3.208a1.353 1.353 0 1 0 1.323 1.352 1.336 1.336 0 0 0-1.323-1.352ZM43.005 94.859c-1.858 0-3.371-1.552-3.371-3.46 0-1.909 1.513-3.46 3.37-3.46 1.859 0 3.372 1.551 3.372 3.46 0 1.908-1.513 3.46-3.371 3.46Zm0-6.417c-1.588 0-2.88 1.323-2.88 2.957 0 1.633 1.292 2.956 2.88 2.956 1.587 0 2.88-1.323 2.88-2.957 0-1.633-1.293-2.956-2.88-2.956ZM47.693 98.066A1.856 1.856 0 1 1 49.5 96.21a1.834 1.834 0 0 1-1.808 1.856Zm0-3.207a1.352 1.352 0 1 0 1.323 1.35 1.334 1.334 0 0 0-1.323-1.35ZM88.315 98.066a1.856 1.856 0 1 1 1.808-1.856 1.834 1.834 0 0 1-1.808 1.856Zm0-3.207a1.353 1.353 0 1 0 1.323 1.35 1.335 1.335 0 0 0-1.323-1.35ZM97.69 104.482a1.863 1.863 0 0 1-1.75-1.113 1.855 1.855 0 0 1 3.243-1.779c.206.306.316.667.316 1.036a1.834 1.834 0 0 1-1.809 1.856Zm0-3.208a1.35 1.35 0 0 0-.996 2.298 1.348 1.348 0 0 0 1.477.306 1.348 1.348 0 0 0 .842-1.252 1.337 1.337 0 0 0-1.323-1.352ZM89.877 107.69c-1.858 0-3.369-1.552-3.369-3.46s1.511-3.46 3.37-3.46c1.857 0 3.37 1.552 3.37 3.46s-1.513 3.46-3.37 3.46Zm0-6.416c-1.587 0-2.878 1.323-2.878 2.956s1.29 2.956 2.878 2.956 2.88-1.323 2.88-2.956-1.29-2.956-2.88-2.956ZM103.939 94.859a1.856 1.856 0 1 1 1.809-1.857 1.838 1.838 0 0 1-1.809 1.857Zm0-3.21a1.353 1.353 0 1 0 1.323 1.353 1.327 1.327 0 0 0-.812-1.245 1.33 1.33 0 0 0-.511-.107ZM69.572 85.235a1.856 1.856 0 1 1 1.808-1.857 1.836 1.836 0 0 1-1.808 1.857Zm0-3.21a1.353 1.353 0 1 0 1.323 1.353 1.336 1.336 0 0 0-1.323-1.353ZM63.317 78.818a1.857 1.857 0 1 1 1.807-1.857 1.834 1.834 0 0 1-1.807 1.857Zm0-3.208a1.352 1.352 0 1 0 1.316 1.351 1.336 1.336 0 0 0-1.316-1.35ZM85.19 82.026A1.856 1.856 0 1 1 87 80.17a1.835 1.835 0 0 1-1.808 1.856Zm0-3.208a1.353 1.353 0 1 0 1.324 1.352 1.336 1.336 0 0 0-1.323-1.352ZM82.067 88.442a1.856 1.856 0 1 1 1.807-1.86 1.835 1.835 0 0 1-1.807 1.86Zm0-3.207a1.352 1.352 0 1 0 1.323 1.35 1.336 1.336 0 0 0-1.323-1.35ZM72.692 95.523a2.521 2.521 0 1 1 2.455-2.52 2.5 2.5 0 0 1-2.455 2.52Zm0-4.538a2.017 2.017 0 1 0 1.964 2.017 1.994 1.994 0 0 0-1.964-2.01v-.007ZM78.94 104.481a1.85 1.85 0 0 1-1.88-2.185 1.857 1.857 0 0 1 3.684.33 1.836 1.836 0 0 1-1.803 1.855Zm0-3.207a1.351 1.351 0 0 0-.304 2.676 1.348 1.348 0 0 0 1.627-1.324 1.337 1.337 0 0 0-1.322-1.352ZM82.067 111.562a2.513 2.513 0 0 1-2.375-1.509 2.522 2.522 0 0 1 4.4-2.419c.28.416.43.906.43 1.407a2.49 2.49 0 0 1-2.455 2.521Zm0-4.536a2.015 2.015 0 0 0-2.037 2.377 2.02 2.02 0 0 0 1.572 1.613 2.019 2.019 0 0 0 2.43-1.975 1.99 1.99 0 0 0-1.965-2.015ZM53.942 104.482a1.86 1.86 0 0 1-1.87-2.192 1.857 1.857 0 0 1 3.682.336 1.834 1.834 0 0 1-1.812 1.856Zm0-3.208a1.352 1.352 0 1 0 1.323 1.352 1.335 1.335 0 0 0-1.323-1.352Z"
        opacity={0.52}
        style={{
          mixBlendMode: "overlay",
        }}
      />
      <path
        fill="#AEA4B3"
        d="M24.256 75.358h99.996V72.15H24.256v3.208Z"
        opacity={0.52}
        style={{
          mixBlendMode: "overlay",
        }}
      />
      <path
        fill="#F5B659"
        d="M124.375 74.554c0-28.348-22.385-51.328-49.997-51.328-27.613 0-49.998 22.98-49.998 51.328"
      />
      <path
        fill="#ECDEA0"
        d="M121.25 74.554c0-26.577-20.986-48.12-46.872-48.12-25.887 0-46.874 21.543-46.874 48.12"
      />
      <path
        fill="#E18D27"
        d="M114.995 74.554c0-23.034-18.188-41.704-40.623-41.704S33.748 51.519 33.748 74.554"
      />
      <path
        fill="#ECDEA0"
        d="M74.13 32.85h.492v38.747H33.754v-.504h40.377V32.85Z"
      />
      <path
        fill="#ECDEA0"
        d="m46.417 45.493 29.016 26.48-38.632-13.22.155-.478 36.363 12.442L46.09 45.87l.327-.377Z"
      />
      <path
        fill="#ECDEA0"
        d="M58.975 35.953 74.601 71.24l-.448.21-15.625-35.288.447-.209Z"
      />
      <path fill="#ECDEA0" d="M74.13 32.85h.492v38.243H115v.504H74.13V32.85Z" />
      <path
        fill="#ECDEA0"
        d="m102.337 45.493.326.377-27.23 24.847 36.365-12.442.154.478-38.633 13.22 29.018-26.48Z"
      />
      <path
        fill="#ECDEA0"
        d="m89.777 35.953.447.209-15.623 35.287-.448-.209 15.624-35.287Z"
      />
      <path
        fill="#AEA4B3"
        d="M50.941 58.262a1.857 1.857 0 1 1-1.802 1.86 1.835 1.835 0 0 1 1.802-1.86Zm0 3.207a1.352 1.352 0 1 0-1.323-1.352 1.336 1.336 0 0 0 1.323 1.352ZM54.065 61.47a1.856 1.856 0 1 1-1.807 1.856 1.834 1.834 0 0 1 1.807-1.857Zm0 3.207a1.353 1.353 0 1 0-1.316-1.351 1.334 1.334 0 0 0 1.316 1.354v-.003ZM40.003 61.47c1.86 0 3.37 1.552 3.37 3.46s-1.51 3.46-3.37 3.46-3.37-1.552-3.37-3.46 1.512-3.46 3.37-3.46Zm0 6.416c1.59 0 2.88-1.323 2.88-2.956 0-1.634-1.29-2.957-2.88-2.957-1.589 0-2.878 1.324-2.878 2.957 0 1.633 1.29 2.956 2.878 2.956ZM47.816 67.886a1.857 1.857 0 1 1-1.808 1.855 1.835 1.835 0 0 1 1.808-1.855Zm0 3.207a1.353 1.353 0 1 0-1.323-1.352 1.336 1.336 0 0 0 1.323 1.352ZM77.51 39.013c1.858 0 3.37 1.553 3.37 3.46 0 1.909-1.519 3.461-3.37 3.461-1.85 0-3.38-1.552-3.38-3.46s1.513-3.46 3.38-3.46Zm0 6.417c1.588 0 2.878-1.323 2.878-2.956s-1.29-2.956-2.878-2.956c-1.587 0-2.88 1.323-2.88 2.956s1.285 2.956 2.88 2.956ZM82.189 45.43a1.857 1.857 0 1 1-1.808 1.855 1.833 1.833 0 0 1 1.808-1.855Zm0 3.208a1.353 1.353 0 1 0-1.323-1.353 1.337 1.337 0 0 0 1.323 1.353ZM91.565 58.262a1.856 1.856 0 1 1-1.808 1.86 1.833 1.833 0 0 1 1.808-1.86Zm0 3.207a1.353 1.353 0 1 0-1.323-1.352 1.337 1.337 0 0 0 1.323 1.352ZM100.939 64.68a1.854 1.854 0 0 1 1.875 2.188 1.86 1.86 0 0 1-1.446 1.485 1.855 1.855 0 0 1-2.237-1.817 1.836 1.836 0 0 1 1.808-1.856Zm0 3.209a1.35 1.35 0 0 0 1.359-1.598 1.353 1.353 0 0 0-2.682.245 1.334 1.334 0 0 0 1.323 1.35v.003ZM110.313 64.68a1.86 1.86 0 0 1 1.75 1.112 1.857 1.857 0 1 1-3.558.744 1.838 1.838 0 0 1 1.808-1.856Zm0 3.209a1.35 1.35 0 0 0 1.27-.814 1.354 1.354 0 0 0-2.363-1.293c-.15.223-.23.486-.23.754-.002.176.031.35.097.513a1.324 1.324 0 0 0 .716.73c.161.069.335.105.51.107v.003ZM105.625 51.845c1.86 0 3.371 1.552 3.371 3.46 0 1.909-1.511 3.46-3.371 3.46-1.859 0-3.369-1.551-3.369-3.46 0-1.908 1.511-3.46 3.369-3.46Zm0 6.417c1.589 0 2.88-1.323 2.88-2.957 0-1.633-1.291-2.956-2.88-2.956s-2.878 1.323-2.878 2.956c0 1.634 1.291 2.957 2.878 2.957ZM100.939 48.638a1.854 1.854 0 0 1 1.875 2.188 1.854 1.854 0 0 1-1.447 1.485 1.855 1.855 0 0 1-2.236-1.818 1.835 1.835 0 0 1 1.808-1.855Zm0 3.207a1.35 1.35 0 0 0 .996-2.298 1.353 1.353 0 0 0-2.319.946 1.336 1.336 0 0 0 1.323 1.352ZM60.311 48.638a1.858 1.858 0 1 1-1.808 1.855 1.835 1.835 0 0 1 1.808-1.855Zm0 3.207a1.353 1.353 0 1 0-1.323-1.352 1.338 1.338 0 0 0 1.323 1.352ZM50.941 42.221a1.857 1.857 0 1 1-1.802 1.857 1.836 1.836 0 0 1 1.802-1.857Zm0 3.21a1.352 1.352 0 1 0-1.323-1.353 1.336 1.336 0 0 0 1.323 1.352ZM58.753 39.013c1.858 0 3.37 1.553 3.37 3.46 0 1.909-1.518 3.461-3.37 3.461s-3.37-1.552-3.37-3.46 1.512-3.46 3.37-3.46Zm0 6.417c1.588 0 2.88-1.323 2.88-2.956s-1.292-2.956-2.88-2.956c-1.588 0-2.88 1.323-2.88 2.956s1.292 2.956 2.88 2.956ZM44.69 51.845a1.857 1.857 0 1 1-1.807 1.857 1.835 1.835 0 0 1 1.808-1.857Zm0 3.208a1.354 1.354 0 1 0-1.322-1.351 1.338 1.338 0 0 0 1.323 1.35ZM79.065 61.47a1.857 1.857 0 1 1-1.808 1.856 1.834 1.834 0 0 1 1.808-1.857Zm0 3.207a1.354 1.354 0 1 0-1.323-1.351 1.336 1.336 0 0 0 1.323 1.354v-.003ZM85.314 67.886a1.856 1.856 0 1 1-1.808 1.855 1.835 1.835 0 0 1 1.808-1.855Zm0 3.207a1.353 1.353 0 1 0-1.323-1.352 1.336 1.336 0 0 0 1.323 1.352ZM63.44 64.68a1.856 1.856 0 1 1-1.806 1.853 1.836 1.836 0 0 1 1.807-1.853Zm0 3.209a1.353 1.353 0 1 0-1.322-1.353 1.334 1.334 0 0 0 1.323 1.35v.003ZM66.564 58.262a1.857 1.857 0 1 1-1.806 1.86 1.833 1.833 0 0 1 1.806-1.86Zm0 3.207a1.352 1.352 0 1 0-1.322-1.352 1.338 1.338 0 0 0 1.322 1.352ZM75.94 51.18a2.52 2.52 0 1 1-2.455 2.522 2.491 2.491 0 0 1 2.455-2.521Zm0 4.537a2.017 2.017 0 1 0-1.958-2.015 1.992 1.992 0 0 0 1.958 2.01v.005ZM69.69 42.221a1.856 1.856 0 1 1-1.808 1.857 1.836 1.836 0 0 1 1.808-1.857Zm0 3.209a1.353 1.353 0 1 0-1.323-1.352 1.337 1.337 0 0 0 1.323 1.352ZM66.564 35.142a2.52 2.52 0 1 1-2.454 2.52 2.499 2.499 0 0 1 2.454-2.52Zm0 4.536a2.017 2.017 0 1 0-1.964-2.017 1.994 1.994 0 0 0 1.964 2.017ZM94.689 42.221a1.856 1.856 0 1 1-1.808 1.857 1.836 1.836 0 0 1 1.808-1.857Zm0 3.209a1.353 1.353 0 1 0-1.323-1.352 1.337 1.337 0 0 0 1.323 1.352Z"
        opacity={0.52}
        style={{
          mixBlendMode: "overlay",
        }}
      />
      <path
        fill="#AEA4B3"
        d="M124.374 71.345H24.379v3.207h99.995v-3.207Z"
        opacity={0.52}
        style={{
          mixBlendMode: "overlay",
        }}
      />
      <path
        fill="#F96020"
        d="M75.928 147.658a9.117 9.117 0 1 0 0-18.234 9.117 9.117 0 0 0 0 18.234Z"
      />
      <path
        fill="#D74816"
        d="M75.929 146.521a7.98 7.98 0 1 0-.001-15.96 7.98 7.98 0 0 0 0 15.96Z"
      />
      <path
        fill="#FFA520"
        d="m68.657 141.537 3.692 3.693 10.06-10.061-3.691-3.692-10.061 10.06Z"
      />
      <path
        fill="#F96020"
        d="M75.11 148.239a9.755 9.755 0 0 0 9.755-9.755c0-5.387-4.368-9.755-9.755-9.755-5.388 0-9.755 4.368-9.755 9.755a9.755 9.755 0 0 0 9.755 9.755Z"
      />
      <path
        fill="#D74816"
        d="M75.108 147.022a8.538 8.538 0 1 0 0-17.076 8.538 8.538 0 0 0 0 17.076Z"
      />
      <path
        fill="#FF9317"
        d="M74.734 130.624h.768a.77.77 0 0 0 .166.012c.222.019.441.041.665.076.523.08 1.037.214 1.533.4a7.886 7.886 0 0 1 5.054 6.402c.022.179.038.36.046.539a.242.242 0 0 0 .011.121v.633a.226.226 0 0 0-.011.121 6.846 6.846 0 0 1-.077.755 7.635 7.635 0 0 1-.792 2.427 7.871 7.871 0 0 1-9.129 3.947 7.805 7.805 0 0 1-4.37-3.154 7.794 7.794 0 0 1-1.33-3.759 2.477 2.477 0 0 0-.024-.276v-.755a.11.11 0 0 0 .01-.058 7.806 7.806 0 0 1 .772-2.995 7.889 7.889 0 0 1 6.54-4.422 1.34 1.34 0 0 0 .168-.014Zm-6.174 7.864a6.557 6.557 0 1 0 6.554-6.559 6.568 6.568 0 0 0-6.061 4.049 6.555 6.555 0 0 0-.498 2.51h.004Z"
      />
      <path
        fill="#FF9317"
        d="M77.086 138.255c.278.046.549.13.805.248.323.146.593.387.775.691.12.209.196.442.223.682.04.304.027.613-.04.913a1.595 1.595 0 0 1-.999 1.176 3.717 3.717 0 0 1-.848.225 6.64 6.64 0 0 1-.588.064c-.07 0-.07 0-.07.075v1.168c0 .073 0 .074-.074.074h-.854c-.083 0-.078.001-.078-.077v-1.129c0-.094.007-.084-.085-.084H74.4c-.068 0-.068 0-.07.07v1.137c0 .086 0 .083-.079.083h-.843c-.081 0-.081 0-.081-.083v-1.167c0-.021-.01-.043-.038-.04h-1.926c-.035 0-.05-.009-.05-.046v-.836c0-.04.016-.052.053-.052h.52c.106-.002.21-.015.313-.039a.283.283 0 0 0 .228-.231c.031-.138.045-.278.043-.419V136.282c0-.133-.014-.265-.04-.396a.297.297 0 0 0-.251-.247 2.03 2.03 0 0 0-.405-.035h-.39c-.07 0-.07 0-.07-.072v-.775c0-.088-.008-.082.08-.083h1.845c.083 0 .083 0 .085-.08v-1.16c0-.029.013-.041.041-.038h.882c.09 0 .082-.009.082.08v1.106c0 .103-.007.092.094.092h.846c.067 0 .067 0 .069-.072v-1.168c0-.029.01-.041.04-.038h.881c.087 0 .084-.013.084.085v1.153c0 .057 0 .057.057.062.304.02.605.069.899.147.162.043.32.102.47.176a1.352 1.352 0 0 1 .735.891c.098.347.104.714.018 1.064-.09.359-.308.673-.613.882-.24.166-.505.291-.785.372-.01.004-.028.002-.038.027Zm-2.758 1.822v1.22c0 .065 0 .067.064.067h.442c.313.007.627-.008.939-.046.184-.023.365-.069.538-.137a.921.921 0 0 0 .558-.611c.088-.286.1-.59.039-.882a.928.928 0 0 0-.412-.624 1.33 1.33 0 0 0-.39-.149 3.522 3.522 0 0 0-.677-.096c-.352-.021-.703 0-1.054-.012-.038 0-.05.015-.047.049.003.034 0 .035 0 .053v1.168Zm0-3.345v1.084c0 .037 0 .055.05.055.378.01.757-.001 1.135-.034.184-.02.366-.064.54-.131a.812.812 0 0 0 .506-.588c.06-.229.07-.469.033-.702a.804.804 0 0 0-.563-.674 2.7 2.7 0 0 0-.735-.129c-.294-.015-.588 0-.882 0h-.031c-.025 0-.037.012-.035.037v.06l-.018 1.022ZM67.59 131.81a2.053 2.053 0 1 0 .002-4.106 2.053 2.053 0 0 0-.001 4.106Z"
      />
      <path
        fill="#FF9317"
        d="M64.51 128.729a2.053 2.053 0 1 0 0-4.106 2.053 2.053 0 0 0 0 4.106Z"
      />
      <path
        fill="#FF9317"
        d="M61.43 125.649a2.053 2.053 0 1 0 0-4.106 2.053 2.053 0 0 0 0 4.106Z"
      />
      <path
        fill="#FF9317"
        d="M58.349 122.568a2.053 2.053 0 1 0 0-4.106 2.053 2.053 0 0 0 0 4.106Z"
      />
      <path
        fill="#F96020"
        d="M82.992 131.81a2.053 2.053 0 1 0 0-4.106 2.053 2.053 0 0 0 0 4.106ZM86.073 128.729a2.053 2.053 0 1 0 0-4.106 2.053 2.053 0 0 0 0 4.106ZM89.153 125.649a2.053 2.053 0 1 0 0-4.106 2.053 2.053 0 0 0 0 4.106ZM92.234 122.568a2.053 2.053 0 1 0 0-4.106 2.053 2.053 0 0 0 0 4.106Z"
      />
      <path
        fill="#883A62"
        d="M53.589 30.247 35.067 17.898l-4.911 6.14a10.912 10.912 0 0 0 2.468 15.894l8.615 5.744"
      />
      <path
        fill="#4D2F47"
        d="M94.728 30.198 113.25 17.85l4.912 6.14a10.9 10.9 0 0 1 2.262 8.49 10.912 10.912 0 0 1-4.729 7.404l-8.617 5.745"
      />
      <path
        fill="#542F5F"
        d="M75.429 110.093v-59.26L35.922 90.34h19.753a19.751 19.751 0 0 1 19.754 19.753Z"
      />
      <path
        fill="#F0E49A"
        d="M35.922 90.34h14.815L75.43 65.648V50.834L35.922 90.34Z"
      />
      <path
        fill="#542F5F"
        d="M68.021 68.118a2.47 2.47 0 1 0 0-4.94 2.47 2.47 0 0 0 0 4.94Z"
      />
      <path
        fill="#172027"
        d="M75.429 110.093v-59.26l39.506 39.507H95.181a19.752 19.752 0 0 0-19.752 19.753Z"
      />
      <path
        fill="#E9642A"
        d="M114.935 90.34H100.12L75.429 65.648V50.834l39.506 39.506Z"
      />
      <path
        fill="#172027"
        d="M82.836 68.118a2.47 2.47 0 1 0 0-4.939 2.47 2.47 0 0 0 0 4.94Z"
      />
      <path
        stroke="#F96020"
        strokeMiterlimit={10}
        strokeWidth={3.61}
        d="M58.237 67.129h30.48"
      />
      <path
        fill="#F96020"
        d="M53.858 83.79c5.536 0 10.024-4.488 10.024-10.024 0-5.536-4.488-10.024-10.024-10.024-5.536 0-10.024 4.488-10.024 10.024 0 5.536 4.488 10.024 10.024 10.024Z"
      />
      <path
        fill="#D74816"
        d="M53.856 82.539a8.773 8.773 0 1 0 0-17.546 8.773 8.773 0 0 0 0 17.546Z"
      />
      <path
        fill="#F96020"
        d="M95.628 84.062c5.536 0 10.024-4.488 10.024-10.024 0-5.536-4.488-10.024-10.024-10.024-5.536 0-10.024 4.488-10.024 10.024 0 5.536 4.488 10.024 10.024 10.024Z"
      />
      <path
        fill="#D74816"
        d="M95.628 82.81a8.773 8.773 0 1 0 0-17.546 8.773 8.773 0 0 0 0 17.547Z"
      />
      <path
        fill="#FFA520"
        d="m45.864 77.06 4.059 4.06 11.062-11.062-4.06-4.06-11.061 11.063ZM88.548 77.746l4.06 4.059 11.061-11.062-4.059-4.06-11.062 11.063Z"
      />
      <path
        fill="#001A1B"
        d="M53.445 78.72c7.605 0 13.77-6.166 13.77-13.771 0-7.606-6.165-13.771-13.77-13.771-7.606 0-13.771 6.165-13.771 13.77 0 7.606 6.165 13.772 13.77 13.772Z"
      />
      <path
        fill="#EFE1DA"
        d="M53.445 73.473a8.525 8.525 0 1 0 0-17.049 8.525 8.525 0 0 0 0 17.05Z"
      />
      <path
        fill="#ED7E29"
        d="M53.445 70.85a5.902 5.902 0 1 0 0-11.803 5.902 5.902 0 0 0 0 11.804Z"
      />
      <path fill="#EFE1DA" d="M54.1 57.809v5.245l4.59-4.59" />
      <path
        stroke="#883A62"
        strokeMiterlimit={10}
        strokeWidth={1.203}
        d="M53.476 74.786c5.445 0 9.859-4.414 9.859-9.86 0-5.445-4.414-9.859-9.86-9.859-5.444 0-9.859 4.414-9.859 9.86 0 5.445 4.415 9.859 9.86 9.859Z"
      />
      <path
        fill="#001A1B"
        d="M95.394 78.293c7.606 0 13.771-6.165 13.771-13.77 0-7.606-6.165-13.772-13.77-13.772-7.606 0-13.772 6.166-13.772 13.771 0 7.606 6.166 13.771 13.771 13.771Z"
      />
      <path
        fill="#EFE1DA"
        d="M95.394 73.047a8.525 8.525 0 1 0 0-17.05 8.525 8.525 0 0 0 0 17.05Z"
      />
      <path
        fill="#ED7E29"
        d="M95.394 70.425a5.902 5.902 0 1 0 0-11.804 5.902 5.902 0 0 0 0 11.804Z"
      />
      <path fill="#EFE1DA" d="M96.05 57.383v5.245l4.591-4.59" />
      <path
        stroke="#883A62"
        strokeMiterlimit={10}
        strokeWidth={1.203}
        d="M95.425 74.36c5.445 0 9.859-4.415 9.859-9.86 0-5.445-4.414-9.859-9.859-9.859s-9.86 4.414-9.86 9.86c0 5.444 4.415 9.859 9.86 9.859Z"
      />
      <path
        stroke="#E9DEDB"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.203}
        d="M81.435 63.55v-7.69a13.17 13.17 0 0 1 13.17-13.17h2.478"
        style={{
          mixBlendMode: "overlay",
        }}
      />
      <path
        stroke="#E9DEDB"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.203}
        d="M80.27 63.504v-8.247A14.112 14.112 0 0 1 94.38 41.145h2.657"
        style={{
          mixBlendMode: "overlay",
        }}
      />
      <path
        stroke="#E9DEDB"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.203}
        d="M77.713 63.57v-9.474a16.225 16.225 0 0 1 16.226-16.233h3.055M67.577 63.55v-7.69a13.17 13.17 0 0 0-13.17-13.17h-2.475"
        style={{
          mixBlendMode: "overlay",
        }}
      />
      <path
        stroke="#E9DEDB"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.203}
        d="M68.743 63.504v-8.247a14.112 14.112 0 0 0-14.112-14.112h-2.652"
        style={{
          mixBlendMode: "overlay",
        }}
      />
      <path
        stroke="#E9DEDB"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.203}
        d="M71.3 63.57v-9.474a16.225 16.225 0 0 0-16.226-16.233h-3.055"
        style={{
          mixBlendMode: "overlay",
        }}
      />
      <path
        fill="#001A1B"
        d="m105.868 55.805 12.618 10.096h-12.618M43.372 55.805 30.754 65.901h12.618"
      />
      <path
        fill="#4D2F47"
        d="M79.997 79.674a5.5 5.5 0 0 1-5.5-5.501v-9.849h6.132a5.803 5.803 0 0 1 5.653 7.125l-.928 3.97a5.502 5.502 0 0 1-5.357 4.255Z"
      />
      <path
        fill="#EB6447"
        d="M79.925 77.88a3.637 3.637 0 1 0 0-7.273 3.637 3.637 0 0 0 0 7.273Z"
      />
      <path
        fill="#3D2F39"
        d="M79.875 76.984a2.69 2.69 0 1 0 0-5.38 2.69 2.69 0 0 0 0 5.38Z"
      />
      <path
        fill="#883A62"
        d="M69.015 79.63a5.5 5.5 0 0 0 5.5-5.501V64.28h-6.133a5.803 5.803 0 0 0-5.653 7.125l.93 3.97a5.5 5.5 0 0 0 5.356 4.255Z"
      />
      <path
        fill="#EB6447"
        d="M69.084 77.836a3.637 3.637 0 1 0 0-7.273 3.637 3.637 0 0 0 0 7.273Z"
      />
      <path
        fill="#3D2F39"
        d="M69.134 76.94a2.69 2.69 0 1 0 0-5.38 2.69 2.69 0 0 0 0 5.38Z"
      />
    </g>
    <defs>
      <clipPath id="prefix__a">
        <rect width={147} height={147} fill="#fff" rx={7} />
      </clipPath>
    </defs>
  </svg>
);
export default BitcoinFace107;
